import Axios from '../axios-instance';

const inventoriesApi = {
  getTreasuryGroups: () => {
    return Axios.get(`/inventories/treasurygroups`).then(({ data }) => data);
  },
  getCountries: () => {
    return Axios.get(`/inventories/countries`).then(({ data }) => data);
  },
  getRegions: () => {
    return Axios.get(`/inventories/regions`).then(({ data }) => data);
  },
  getAreas: () => {
    return Axios.get(`/inventories/areas`).then(({ data }) => data);
  },
  getRoles: () => {
    return Axios.get(`/inventories/roles`).then(({ data }) => data);
  },
  getSuppliers: () => {
    return Axios.get(`/Users/GetSupliers`).then(({ data }) => data);
  },
  getClaimTypes: () => {
    return Axios.get(`/Inventories/claimTypes`).then(({ data }) => data);
  },
  getCriticalSuppliers: () => {
    return Axios.get(`/Users/GetSupliers?critico=true`).then(({ data }) => data);
  },
};

export default inventoriesApi;
